// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Force popover to match app theme via CSS vars set on :root[data-theme] */
[data-tour-elem="popover"] {
  background: var(--bg-primary) !important;
  background-color: var(--bg-primary) !important;
  color: var(--text-primary) !important;
  border: 1px solid var(--border-primary) !important;
}

/* All text inside should respect theme */
[data-tour-elem="popover"] * {
  -webkit-text-fill-color: inherit;
}
`, "",{"version":3,"sources":["webpack://./src/styles/OnboardingTour.css"],"names":[],"mappings":"AAAA,2EAA2E;AAC3E;EACE,wCAAwC;EACxC,8CAA8C;EAC9C,qCAAqC;EACrC,kDAAkD;AACpD;;AAEA,yCAAyC;AACzC;EACE,gCAAgC;AAClC","sourcesContent":["/* Force popover to match app theme via CSS vars set on :root[data-theme] */\n[data-tour-elem=\"popover\"] {\n  background: var(--bg-primary) !important;\n  background-color: var(--bg-primary) !important;\n  color: var(--text-primary) !important;\n  border: 1px solid var(--border-primary) !important;\n}\n\n/* All text inside should respect theme */\n[data-tour-elem=\"popover\"] * {\n  -webkit-text-fill-color: inherit;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
